import React, { Component } from 'react';
import { MasterLayout } from 'components/layouts';
import title from 'constants/TitlePages.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { signinWithTicket } from 'base/actions';
import { toastr } from 'react-redux-toastr';

class SigninWithTicket extends Component {
  constructor(props, context) {
    super(props, context);
    this.signinWithTicket = this.signinWithTicket.bind(this);

    this.state = {
      ticketId: null
    };
  }

  componentWillMount() {
    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.setState({ticketId: this.props.match.params.id});
    }
  }

  componentDidMount() {
    document.title = title.signin;
    if (this.state.ticketId) {
      this.signinWithTicket(this.state.ticketId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth && nextProps.auth.isAuthenticated) {
      this.props.history.push('/');
    }
  }

  signinWithTicket(id) {
    this.props.dispatch(signinWithTicket(id)).then(response => {
      if (
        response.isAuthenticated === true &&
        response.businessData
      ) {
        toastr.success('Thành công!', 'Bạn đã đăng nhập thành công.');
        this.props.history.push('/');
      } else {
        this.props.history.push(this.props.loginPage);
        toastr.error('Đăng nhập thất bại!', 'Ticket không hợp lệ.');
      }
    }).catch(err => {
      console.log(err)
    });
  }
  render() {
    return (
      <MasterLayout>
      </MasterLayout>
    );
  }
}

SigninWithTicket.defaultProps = {
  loginPage: '/signin'
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(SigninWithTicket));


// WEBPACK FOOTER //
// ./pages/SigninWithTicket.jsx